import { useApi } from '@/api';
import { LinkButton } from '@/components';
import {
  useIsMobile,
  HeatmapActivity,
  HeatmapSkeleton
} from '@blockanalitica/ui';
import type { HeatmapData } from '@blockanalitica/ui/package/types/src/components/charts/Heatmap/Heatmap';

export default function WalletActivity({
  marketAddress,
  walletAddress
}: {
  marketAddress: string;
  walletAddress: string;
}) {
  const isMobile = useIsMobile();
  const daysAgo = isMobile ? 150 : 365;
  const [data, error] = useApi<HeatmapData[]>({
    url: `/markets/${marketAddress}/wallets/${walletAddress}/activity/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <HeatmapSkeleton />;
  }
  return (
    <HeatmapActivity
      title="Activity"
      action={
        <LinkButton variant="primary" to="activity">
          view all
        </LinkButton>
      }
      data={data}
      daysAgo={daysAgo}
    />
  );
}
